<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form
    #fdf="ngForm"
    novalidate
  >
    <div class="row m-0 col-md-12 p-0 formborder">
      <div class="col-md-4 p-1">
        <span>Employee Name </span>
        <input required type="text" #refProductName="ngModel" name="EmployeeName" id="EmployeeName" placeholder="Employee Name"
               [(ngModel)]="EmployeeName" class="form-control input-text-css" disabled>
      </div>
      <div class="col-md-4 p-1">
        <span> Designation </span>
        <select name="SelectRoleId" id="SelectRoleId" disabled [(ngModel)]="SelectRoleId" class="form-control input-text-css">

          <option *ngFor="let rolesDropdownData of RolesDropdownData" [value]="rolesDropdownData.RoleId">
            {{rolesDropdownData.Role_Name}}
          </option>
        </select>
      </div>
      <div class="col-md-4 p-1">
        <span>Reporting Manager </span>
        <select name="EmpManagerId" id="EmpManagerId" disabled [(ngModel)]="EmpManagerId" class="form-control input-text-css">

          <option *ngFor="let reportingManager of ReportingManagerDropdown" [value]="reportingManager.EmpId">
            {{reportingManager.EmpName}}
          </option>
        </select>
      </div>
      <!-- <div class="col-md-3">
        <button
          type="button"
          (click)="AddBranchEmployeeProcess()"
          class="mt-3 btn font-size-12 button-btn"
        >
          Add+
        </button>
      </div> -->
    </div>
  </form>
</div>
<div class="process-rights-panel">

  <!-- Loading -->
  <div *ngIf="loading" class="state-msg">Loading process rights...</div>

  <!-- Error -->
  <div *ngIf="!loading && loadError" class="state-msg error">
    {{ loadError }}
    <button class="btn-link" (click)="loadRights()">Retry</button>
  </div>

  <!-- Empty -->
  <div *ngIf="!loading && !loadError && branches.length === 0" class="state-msg">
    No branch / product / process assignments found for this employee.
    Assign branches, products and processes in the earlier tabs first.
  </div>

  <!-- Content -->
  <div *ngIf="!loading && !loadError && branches.length > 0">

    <div class="action-bar">
        <button class="btn btn-secondary" (click)="expandAll()">Expand All</button>
        <button class="btn btn-secondary" (click)="collapseAll()">Collapse All</button>
        <div class="search-box">
            <input
            type="text"
            placeholder="Search branch or product..."
            [(ngModel)]="searchTerm"
            [ngModelOptions]="{ standalone: true }"
            />
            <button class="clear-btn" *ngIf="searchTerm" (click)="clearSearch()" aria-label="Clear search">&times;</button>
        </div>

      <span class="spacer"></span>
      <span *ngIf="hasChanges" class="dirty-indicator">
        {{ changeCount }} unsaved change{{ changeCount > 1 ? 's' : '' }}
      </span>
      <span *ngIf="saveMessage" class="save-msg">{{ saveMessage }}</span>

      <button class="btn btn-secondary" [disabled]="!hasChanges || saving" (click)="discardChanges()">
        Discard
      </button>
      <button class="btn btn-primary" [disabled]="!hasChanges || saving" (click)="saveChanges()">
        {{ saving ? 'Saving...' : 'Save Changes' }}
      </button>
    </div>

    <div class="branch-group" *ngFor="let branch of branches; trackBy: trackByBranchId" [hidden]="!branchHasVisibleContent(branch)">
      <div class="branch-header" (click)="toggleBranch(branch)">
        <span class="chevron" [class.collapsed]="!isBranchExpanded(branch)">&#9660;</span>
        <span class="branch-name">{{ branch.branchName }}</span>
      </div>

      <div class="branch-body" *ngIf="isBranchExpanded(branch)">

        <div class="product-group" *ngFor="let product of branch.products; trackBy: trackByProductId" [hidden]="!productVisible(branch, product)">
          <div class="product-header" (click)="toggleProduct(product)">
            <span class="chevron" [class.collapsed]="!isProductExpanded(product)">&#9660;</span>
            <span class="product-name">{{ product.productName }}</span>
          </div>

          <!-- <table class="rights-table" *ngIf="!product.collapsed">
            <thead>
              <tr>
                <th class="slab-col">From Amount</th>
                <th class="slab-col">To Amount</th>
                <th *ngFor="let col of product.processColumns">{{ col.processName }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let slab of product.slabs; trackBy: trackByParentId">
                <td>{{ slab.fromAmount }}</td>
                <td>{{ slab.toAmount }}</td>
                <td *ngFor="let col of product.processColumns" class="checkbox-cell">
                  <input
                    type="checkbox"
                    [checked]="cellFor(slab, col.processId)?.isAllow"
                    (change)="toggle(slab, col.processId, col.processName)"
                  />
                </td>
              </tr>
            </tbody>
          </table> -->
          <div class="rights-table-wrapper" *ngIf="isProductExpanded(product)">
  <table class="rights-table">
    <thead>
      <tr>
        <th class="slab-col">From Amount</th>
        <th class="slab-col" style="left: 110px;">To Amount</th>
        <th *ngFor="let col of product.processColumns">{{ col.processName }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let slab of product.slabs; trackBy: trackByParentId">
        <td class="slab-col">{{ slab.fromAmount }}</td>
        <td class="slab-col" style="left: 110px;">{{ slab.toAmount }}</td>
        <td *ngFor="let col of product.processColumns" class="checkbox-cell">
          <input
            type="checkbox"
            [checked]="cellFor(slab, col.processId)?.isAllow"
            (change)="toggle(slab, col.processId, col.processName, col.level)"
          />
        </td>
      </tr>
    </tbody>
  </table>
</div>
        </div>
      </div>
    </div>

    <!-- <div class="action-bar bottom">
      <button class="btn btn-secondary" [disabled]="!hasChanges || saving" (click)="discardChanges()">
        Discard
      </button>
      <button class="btn btn-primary" [disabled]="!hasChanges || saving" (click)="saveChanges()">
        {{ saving ? 'Saving...' : 'Save Changes' }}
      </button>
    </div> -->

  </div>
</div>